/**
 * ベースパス
 * - dev/本番環境: 通常は '/opportunity-portal'（nginx が /opportunity-portal/* を opportunity-portal にルーティング）
 * - ローカル開発環境: 通常は '/opportunity-portal'（index.html などで設定）
 * - 上記が未設定の場合: 空文字 ''（ルートパス配下で動作させる想定）
 */
const rawBasePath = (typeof window !== 'undefined' && window.__BASE_PATH__) || import.meta.env?.BASE_PATH || ''

/** '/' や末尾スラッシュを正規化し、二重スラッシュを防止する */
export function normalizeBasePath(path: string): string {
  if (!path || path === '/') return ''
  return path.replace(/\/+$/, '')
}

export const BASE_PATH = normalizeBasePath(rawBasePath)

/** GitHub Codespaces 環境かどうか */
const isCodespaces = typeof window !== 'undefined' && window.location.hostname.endsWith('.app.github.dev')

/** ローカル開発環境かどうか（localhost / GitHub Codespaces） */
export const isLocalDev = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || isCodespaces)

/**
 * dracaena のベースURL
 * - dev/本番環境: ''（相対パス、nginx経由でルーティング）
 * - ローカル開発環境: index.html などで任意の URL を設定可能
 * - 上記が未設定の場合: 空文字 ''（必要であれば利用側で 'http://localhost:8080' などにフォールバックする想定）
 */
export const DRACAENA_BASE_URL =
  (typeof window !== 'undefined' && window.__DRACAENA_BASE_URL__) || import.meta.env?.DRACAENA_BASE_URL || ''

/**
 * バックエンドAPIのベースURL
 * 常に BASE_PATH と同じ値（相対パス）を返す。
 * - ローカル/Codespaces: Bun dev server (3003) の proxyToBackend が BASE_PATH を除去して localhost:3004 に転送
 * - dev/本番環境: nginx が /opportunity-portal/api/* をバックエンドにルーティング
 * port 3004 はコンテナ内部専用。ブラウザに公開する必要がない。
 */
export const API_BASE_URL = normalizeBasePath(rawBasePath)
